import { useStream } from '@components/Stream/hooks/useStream';
/**
  chitchu:react:  2:17 PM
  Heard of the banana problem?
  You only needed the banana, but it came with a gorilla holding a banana and the whole jungle.
  That’s the same when importing getStream
 */
export default function Banana() {
  useStream();
  return null;
}
